import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'

// results and dataStartIndex needed for a basic grid
// for View Button: viewButtonDataIndex and location needed
// alignment is formatted like ['right', 'center', 'left']
// for total calculations: totalColumn, formatter, and totalFunction needed
// doesNotHaveNumberRow is to skip automatic numbering
export default function ResultsGrid(results, dataStartIndex, viewButtonDataIndex, location, alignment, totalColumn, formatter, totalFunction, ignoreRowIndex, doesNotHaveNumberRow, formatterIndexes ) {
  let resultRows = []
  //let total = 0
  for (let i = 0; i < results.reportData.length; i++) {
    const row = []
    for (let j = dataStartIndex; j < results.reportData[i].length; j++) {
      if (j !== ignoreRowIndex) {
        if (j === dataStartIndex  && !doesNotHaveNumberRow) {
          row.push(<td style={{ textAlign: 'right'}} key={-1}>{i+1}</td>)
        }
        if (totalColumn && totalColumn === j+1) {
          totalFunction(results.reportData[i][j])
          if (formatter) {
            row.push(<td key={j} align={alignment ? alignment[j] : 'right'}>{formatter.format(results.reportData[i][j])}</td>)
          } else {
            row.push(<td key={j} align={alignment ? alignment[j] : 'right'}>{results.reportData[i][j]}</td>)
          }
        } else {
          if (formatter) {
            let formatted = false
            if (formatterIndexes) {
              for (let k = 0; k < formatterIndexes.length; k++) {
                console.log(k, j, formatterIndexes[k] === j)
                if (formatterIndexes[k] === j) {
                  formatted = true
                  row.push(<td key={j} align={alignment ? alignment[j] : 'left'}>{formatter.format(results.reportData[i][j])}</td>)
                } 
              }
            }
            if (!formatted) {
              row.push(<td key={j} align={alignment ? alignment[j] : 'left'}>{results.reportData[i][j]}</td>)
            }
          } else {
            row.push(<td key={j} align={alignment ? alignment[j] : 'left'}>{results.reportData[i][j]}</td>)
          }
        }
      }
    }
    if (viewButtonDataIndex || viewButtonDataIndex === 0) {
      row.push(<td key={-2} style={{verticalAlign: 'middle', width: 'auto', textAlign: 'center' }}><Link to={`/object/${results.reportData[i][viewButtonDataIndex]}?source=${location.pathname}${location.search}`}><Button color="primary" size="sm">View</Button></Link></td>)
    }
    resultRows.push(<tr key={i}>{row}</tr>)
  }
  return resultRows
}